/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enable_TranslationInputs */



/**
* | output |
* | --- |
* | "Enable Translation" |
*
* @param {Enable_TranslationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const enable_translation = /** @type {((inputs?: Enable_TranslationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enable_TranslationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Activer la traduction")
	if (locale === "de") return /** @type {LocalizedString} */ ("Übersetzung aktivieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Abilita traduzione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Включить перевод")
	if (locale === "es") return /** @type {LocalizedString} */ ("Habilitar traducción")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("启用翻译")
	if (locale === "ja") return /** @type {LocalizedString} */ ("翻訳を有効にする")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अनुवाद सक्षम करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ativar tradução")
	return /** @type {LocalizedString} */ ("Enable Translation")
});